import Zype from "../../../jsx/components/Dashboard/Zype/zype";

const ZypeWrapper = () => {
  return <Zype />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.admin,
  _enum.ROUTE_PERSONAS.connector,
  _enum.ROUTE_PERSONAS.manager,
];

export default constore(ZypeWrapper);
